import React, { Component } from "react";
import { connect } from "react-redux";
import * as actions from "../../../../../actions/actions";
import moment from "moment";
//
import {isSameDay} from '../../../../../functions/general/general'
import { getAnnualWorkloadData } from "../../../../../functions/api/orders";

class Weeks extends Component {
  state = {
    annualWorkload: [],
  };

  componentDidMount() {
    this.loadAnnualWorkload();
  }

  componentDidUpdate(prevProps) {
    if (
      this.getWorkloadRequestKey(prevProps) !==
      this.getWorkloadRequestKey(this.props)
    ) {
      this.loadAnnualWorkload();
    }
  }

  componentWillUnmount() {
    this.annualWorkloadRequestId = (this.annualWorkloadRequestId || 0) + 1;
  }

  getWorkloadRequestKey = (props) => {
    const weeks = props.orders.weeks_array || [];
    const firstWeek = weeks[0];
    const lastWeek = weeks[weeks.length - 1];

    return JSON.stringify({
      from: firstWeek?.start_week,
      to: lastWeek?.end_week,
      departmentId: props.login.selectedDepartment?._id,
      managerId: props.login.selectedManager?._id,
      showBids: props.process?.show_bids,
    });
  };

  loadAnnualWorkload = async () => {
    const requestId = (this.annualWorkloadRequestId || 0) + 1;
    this.annualWorkloadRequestId = requestId;
    const weeks = this.props.orders.weeks_array || [];
    if (!weeks.length) {
      this.setState({ annualWorkload: [] });
      this.props.onAnnualWorkloadProcessNamesChange([]);
      return;
    }

    this.setState({ annualWorkload: [] });
    this.props.onAnnualWorkloadProcessNamesChange([]);

    const { selectedDepartment, selectedManager } = this.props.login;

    try {
      const annualWorkload = await getAnnualWorkloadData(
        weeks[0].start_week,
        weeks[weeks.length - 1].end_week,
        selectedDepartment?._id,
        selectedManager?._id,
        this.props.process?.show_bids
      );

      if (
        !Array.isArray(annualWorkload) ||
        annualWorkload.some((week) => !Array.isArray(week.processes))
      ) {
        throw new Error("The annual workload API response has an invalid shape");
      }

      if (requestId === this.annualWorkloadRequestId) {
        this.setState({ annualWorkload });
        this.props.onAnnualWorkloadProcessNamesChange(
          Array.from(
            new Set(
              annualWorkload.reduce(
                (processNames, week) =>
                  processNames.concat(
                    week.processes.map((process) => process.process_name)
                  ),
                []
              )
            )
          )
        );
      }
    } catch (error) {
      if (requestId === this.annualWorkloadRequestId) {
        console.error("Failed to load annual workload data", error);
      }
    }
  };

  holidayChecker = (start_week, end_week, startDay = false) => {
    for (let holiday of this.props.login.user.holidays) {
      let holiday_week_formated = moment(holiday.date).format();
      if(this.props.login.user && this.props.login.user.mps_view === 'day') {
          if(isSameDay(moment(startDay).toDate(), moment(holiday_week_formated).toDate() )){
          return { holiday: holiday.name, isholiday: true }
          }
      }
       else {
            if (
                start_week <= holiday_week_formated &&
                holiday_week_formated <= end_week
            ) {
                return { holiday: holiday.name, isholiday: true }
            }
      }



    }

    return false;
  };

  shouldComponentUpdate(nextProps, nextState) {
    return (
      nextProps.orders.weeks_array !== this.props.orders.weeks_array ||
      nextProps.orders.orders !== this.props.orders.orders ||
      nextProps.annualWorkloadProcessNames !==
        this.props.annualWorkloadProcessNames ||
      this.getWorkloadRequestKey(nextProps) !==
        this.getWorkloadRequestKey(this.props) ||
      nextState.annualWorkload !== this.state.annualWorkload
    );
  }

  getAnnualWorkload = (week) => {
    const weekKey = moment(week.start_week).format("YYYY-MM-DD");
    const processes = this.state.annualWorkload.find(
      (workloadWeek) => workloadWeek.week_start === weekKey
    )?.processes || [];
    return new Map(processes.map((process) => [process.process_name, process]));
  };

  configureCurrent = (date, index) => {
      if(this.props.login.user.mps_view === 'day'){
          if(isSameDay(new Date(date.start_day_formated), new Date())){
              this.props.getCurrentWeek(index)
              return true
          } else {
              return false
          }
          
      } else {
        let current_week_num_start_day = moment(new Date()).startOf("week");
        current_week_num_start_day = moment(current_week_num_start_day._d).format("l")

        if(current_week_num_start_day ===  moment( new Date(date.start_week)).format("l")){
          this.props.getCurrentWeek(index)
           return true
        } else {
            return false
        }
        
      }
  }

  render() {
    return (
      <div className="weeks__holiday__bar">
        <div className="weeks" >
          {this.props.orders.weeks_array.map((w, i) => (
            <div
              className="week"
            //   id={ 
                
            //     current_week_num_start_day ===  moment( new Date(w.start_week)).format("l")  
            //       ? "current__week"
            //       : ""
            //   }
            id={this.configureCurrent(w, i) ? "current__week":null}
              key={i}
            >
              {w.week}
            </div>
          ))}
        </div>
        <div className="weeks__dates">
          {this.props.orders.weeks_array.map((w, i) => (
            <div
              className="week__date"
            //   id={
            //     current_week_num_start_day ===  moment( new Date(w.start_week)).format("l") 
            //       ? "current__week"
            //       : ""
            //   }
              id={this.configureCurrent(w, i) ? "current__week":null}
              key={i}
            >
              {w.week_dates}
            </div>
          ))}
        </div>
        <div className="holidays">
          {this.props.orders.weeks_array.map((w, i) => (

            <div
              className="holiday"
            //   id={
            //     current_week_num_start_day ===  moment( new Date(w.start_week)).format("l") 
            //       ? "current__week"
            //       : ""
            //   }
            id={this.configureCurrent(w, i) ? "current__week":null}
              key={i}
            >
               <i className="fas fa-circle" style = {{color: 'red', display: w.overloaded ? 'block' : 'none'}}></i>
               <i className="fas fa-circle" style = {{display: this.holidayChecker(w.start_week, w.end_week, w.start_day_formated) ? 'block': 'none'}}></i>
            </div>
          ))}
        </div>
        <div
          className="workload_data"
          style={{
            height: Math.max(
              37,
              (this.props.annualWorkloadProcessNames?.length || 0) * 20
            ),
          }}
        >
          {this.props.orders.weeks_array.map((week, index) => (
            <div className="workload_data__week" id={this.configureCurrent(week, index) ? "current__week":null} key={`${week.start_week}-${index}`}>
              {this.props.annualWorkloadProcessNames?.map((processName) => {
                const workload = this.getAnnualWorkload(week).get(processName);
                return (
                  <div className="workload_data__item" key={processName}>
                    {workload
                      ? `${workload.total_quantity}`
                      : ""}
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      </div>
    );
  }
}

function mapStateToProps({ router, orders, login, process }) {
  return { router, orders, login, process };
}

export default connect(mapStateToProps, actions)(Weeks);
